<geaui-page-layout [headerTemplate]="header" [contentTemplate]="content" [sidebarTemplate]="sidebar">
  <ng-template #header>
    @if (noAuth !== undefined) {
      <geaui-header
        [noAuth]="noAuth"
        [showBanner]="false"
        [disableSignupMobile]="true"
        [disableLoginMobile]="true"
        [headerTitle]="headerTitle">
      </geaui-header>
    }
  </ng-template>
  <ng-template #content>
    @if ((!tokenReady || !userReady) && !loggedOutPageReady) {
      <div class="spinner">
        <p-progressSpinner animationDuration="2s" strokeWidth="4"></p-progressSpinner>
      </div>
    }

    <div class="content-body">
      <router-outlet></router-outlet>
    </div>
  </ng-template>
  <ng-template #sidebar>
    @if (!noAuth && tokenReady) {
      <!-- <CHANGE ME> - Change to Icon of your Choice -->
      <geaui-sidebar-v2
        [navigationItems]="navItems"
        [slimView]="true"
        [adminViewNavigationItems]="adminNavItems"
        [bottomNavigation]="botItems"
        [devisionName]="headerTitle"
        [devisionIconPath]="environment.appContentStorageURL + 'core/asset/icons/24px_asset-app.svg'"
        devisionIconBackgroundColor="var(--geaui-night-blue)">
      </geaui-sidebar-v2>
    }
  </ng-template>
</geaui-page-layout>
